<script lang="ts">
  import { addDataAttrs } from '@centerhealth/fe/heap';

  export let type: 'app-store' | 'google-play' = 'app-store';

  const link =
    type === 'app-store'
      ? 'https://itunes.apple.com/app/center-the-diabetes-app/id1231963619?utm_source=site_cta'
      : 'https://play.google.com/store/apps/details?id=com.distillr.app&utm_source=site_cta';
</script>

<a
  use:addDataAttrs={{ action: 'cta', subAction: 'app-store', value: type }}
  href={link}
  target="_blank"
>
  <div class="store-btn inline-block bg-no-repeat	store-btn--{type}" />
</a>

<style>
  .store-btn {
    border-radius: 10px;
    height: 50px;
    width: 160px;
    background-size: 100% auto;
  }
  .store-btn--app-store {
    background-image: var(--store-sprite);
  }
  .store-btn--google-play {
    background-image: var(--store-sprite);
    background-position: left -50px;
  }
</style>
